if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (this.form.dataset.gbAtcSource === 'gb-pack-popup') {
        const popupCartDrawer = document.querySelector('cart-drawer');
        if (popupCartDrawer) this.cart = popupCartDrawer;
      }

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      } 
      
      config.body = formData;

      this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.trackAddToCartError(response);
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.trackAddToCartSuccess(response);

          if (this.skipCart) {
            window.location = "/checkout";
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          this.trackAddToCartError({ description: e && e.message ? e.message : 'add to cart error' });
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.clearGbTrackingContext();
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    clearGbTrackingContext() {
      delete this.form.dataset.gbAtcSource;
      delete this.form.dataset.gbAtcItems;
      delete this.form.dataset.gbAtcCurrency;
      delete this.form.dataset.gbAtcProductId;
      delete this.form.dataset.gbAtcProductHandle;
      delete this.form.dataset.gbAtcProductTitle;
    }

    dispatchGbTrackingEvent(name, detail) {
      try {
        document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
      } catch (e) {}
    }

    pushGbDataLayerEvent(name, detail) {
      window.dataLayer = window.dataLayer || [];
      if (!Array.isArray(window.dataLayer)) return;
      const payload = { event: name };
      if (detail && typeof detail === 'object') {
        Object.keys(detail).forEach((key) => {
          payload[key] = detail[key];
        });
      }
      window.dataLayer.push(payload);
    }

    parseGbTrackedItems(response) {
      let trackedItems = [];

      if (response && Array.isArray(response.items)) {
        trackedItems = response.items.map((item) => ({
          id: Number(item.id || item.variant_id || 0),
          quantity: Number(item.quantity || 0),
          price: this.resolveTrackedUnitPriceCents(item),
          title: item.product_title || item.title || '',
          option: item.variant_title || ''
        }));
      }

      if (!trackedItems.length && response && (response.id || response.variant_id)) {
        trackedItems = [{
          id: Number(response.id || response.variant_id || 0),
          quantity: Number(response.quantity || 1),
          price: this.resolveTrackedUnitPriceCents(response),
          title: response.product_title || response.title || '',
          option: response.variant_title || ''
        }];
      }

      if (!trackedItems.length && this.form.dataset.gbAtcItems) {
        try {
          const parsed = JSON.parse(this.form.dataset.gbAtcItems);
          if (Array.isArray(parsed)) trackedItems = parsed;
        } catch (e) {}
      }

      return trackedItems.filter((item) => Number(item.id || 0) > 0 && Number(item.quantity || 0) > 0);
    }

    resolveTrackedUnitPriceCents(item) {
      const quantity = Math.max(1, Number(item && item.quantity ? item.quantity : 1));
      const finalLinePrice = Number(item && item.final_line_price ? item.final_line_price : 0);
      const linePrice = Number(item && item.line_price ? item.line_price : 0);
      const finalPrice = Number(item && item.final_price ? item.final_price : 0);
      const price = Number(item && item.price ? item.price : 0);

      if (finalLinePrice > 0) return Math.round(finalLinePrice / quantity);
      if (linePrice > 0) return Math.round(linePrice / quantity);
      if (finalPrice > 0) return finalPrice;
      if (price > 0) return price;
      return 0;
    }

    buildGbTrackingPayload(response) {
      const source = this.form.dataset.gbAtcSource || 'product-form';
      const currency = this.form.dataset.gbAtcCurrency || (window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR');
      const items = this.parseGbTrackedItems(response);

      let totalQuantity = 0;
      let totalValueCents = 0;
      const ecommerceItems = items.map((item) => {
        const quantity = Number(item.quantity || 0);
        const priceCents = Number(item.price || 0);
        totalQuantity += quantity;
        totalValueCents += priceCents * quantity;
        return {
          item_id: String(item.id || ''),
          item_name: item.title || '',
          item_variant: item.option || '',
          quantity: quantity,
          price: Number((priceCents / 100).toFixed(2))
        };
      });

      const contentIds = ecommerceItems.map((item) => item.item_id);
      const contents = ecommerceItems.map((item) => ({
        id: item.item_id,
        quantity: item.quantity,
        item_price: item.price
      }));

      return {
        source: source,
        product_id: this.form.dataset.gbAtcProductId || '',
        product_handle: this.form.dataset.gbAtcProductHandle || '',
        product_title: this.form.dataset.gbAtcProductTitle || '',
        currency: currency,
        total_quantity: totalQuantity,
        total_value: Number((totalValueCents / 100).toFixed(2)),
        total_value_cents: totalValueCents,
        items: ecommerceItems,
        content_ids: contentIds,
        contents: contents,
        num_items: totalQuantity
      };
    }

    isGtmDataLayerPresent() {
      if (!Array.isArray(window.dataLayer)) return false;
      return window.dataLayer.some((entry) => entry && typeof entry === 'object' && Object.prototype.hasOwnProperty.call(entry, 'gtm.start'));
    }

    trackMetaAddToCart(payload) {
      if (!payload || payload.source !== 'gb-pack-popup') return;
      if (this.isGtmDataLayerPresent()) return;
      if (typeof window.fbq !== 'function') return;
      if (!Array.isArray(payload.contents) || !payload.contents.length) return;

      try {
        window.fbq('track', 'AddToCart', {
          content_type: 'product',
          content_ids: payload.content_ids,
          contents: payload.contents,
          currency: payload.currency,
          value: payload.total_value,
          num_items: payload.num_items
        });
      } catch (e) {}
    }

    trackAddToCartSuccess(response) {
      const payload = this.buildGbTrackingPayload(response);
      this.dispatchGbTrackingEvent('gb:add_to_cart_success', payload);
      this.pushGbDataLayerEvent('gb_add_to_cart_success', payload);
      this.trackMetaAddToCart(payload);

      if (payload.source === 'gb-pack-popup') {
        this.dispatchGbTrackingEvent('gb:popup_atc_success', payload);
        this.pushGbDataLayerEvent('gb_popup_atc_success', payload);
      }

      this.pushGbDataLayerEvent('add_to_cart', {
        event_source: payload.source,
        currency: payload.currency,
        value: payload.total_value,
        content_ids: payload.content_ids,
        contents: payload.contents,
        num_items: payload.num_items,
        ecommerce: {
          currency: payload.currency,
          value: payload.total_value,
          items: payload.items
        }
      });
    }

    trackAddToCartError(errorResponse) {
      const payload = this.buildGbTrackingPayload(errorResponse || {});
      payload.error = errorResponse && errorResponse.description ? errorResponse.description : 'add_to_cart_error';
      this.dispatchGbTrackingEvent('gb:add_to_cart_error', payload);
      this.pushGbDataLayerEvent('gb_add_to_cart_error', payload);

      if (payload.source === 'gb-pack-popup') {
        this.dispatchGbTrackingEvent('gb:popup_atc_error', payload);
        this.pushGbDataLayerEvent('gb_popup_atc_error', payload);
      }
    }
  });
}